import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledInputTip = styled.p`
    ${mixins.setFont({ $color: colorsPalettes.carbon["300"], $size: 12 })};
    line-height: 16px;
    margin: 4px 0 0;
`;
